<template>
  <v-container py-0>
    <Navbar
      :hasDrawer="true"
      :title="computedTitle"
    >
      <template v-if="!pedidosSelected.length" slot="actions">
        <v-btn
          icon
          :loading="loading"
          @click="insertPedidosAPI"
        ><v-icon>mdi-database-sync</v-icon>
        </v-btn>
        <v-btn
          icon
          :loading="loading"
          @click="getPedidosAPI"
        ><v-icon>mdi-cached</v-icon>
        </v-btn>
        <v-btn
          icon
          @click.stop="filterDrawer = !filterDrawer"
        ><v-icon>mdi-filter-variant</v-icon>
        </v-btn>
        <v-btn icon @click="searchBox = !searchBox">
          <v-icon>{{ iconSearch }}</v-icon>
        </v-btn>
      </template>
      <template v-else slot="actions">
        <v-btn icon @click="selectAllPedidos">
          <v-icon>mdi-check-all</v-icon>
        </v-btn>
        <v-btn icon @click="clearPedidosSelected">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <Menu
          :items="menuItems"
          @gerarPedido="geraPedido"
          @enviarPedido="enviaPedido"
          @deletePedido="deletePedidos(pedidosSelected)"
        />
      </template>
    </Navbar>
    <v-navigation-drawer
      v-model="filterDrawer"
      absolute
      temporary
    >
      <h4 class="text-center py-3">Filtros</h4>
      <v-divider></v-divider>
      <v-container>
        <v-row>
          <v-col cols="12" class="pb-0">
            <v-select
              dense
              v-model="orderSelected"
              hide-details
              label="Ordenar por"
              :items="orderItems"
            ></v-select>
          </v-col>
          <v-col cols="12">
            <v-btn
              text
              @click.stop="filterDrawer = false"
            >Cancelar</v-btn>
            <v-btn
              color="primary"
              @click.stop="applyFilters"
            >Aplicar</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-navigation-drawer>
    <v-row v-if="searchBox">
      <v-col cols="12" class="pb-0">
        <SearchBox
          id="searchBox"
          @search="filters.search = $event"
        />
      </v-col>
    </v-row>
    <ListPedidos
      :filters="filters"
    />
    <p v-if="error" class="caption text-center font-weight-bold red--text">{{ error }}</p>
    <!-- Button Create Pedido -->
    <v-fab-transition>
      <v-btn
        fixed
        fab
        dark
        bottom
        right
        color="primary"
        @click="createPedido({ idColaborador, idEmpresa: usuario_licenca.id_empresa || 1 })"
      ><v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-fab-transition>
    <ModalLoading
      :modal="modalLoading"
      @close="modalLoading = false"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { pedidoService } from '@/services/pedidoService';
import ListPedidos from '@/components/shared/ListPedidos';
import SearchBox from '@/components/shared/SearchBox';
import Menu from '@/components/shared/Menu';

export default {
  name: 'Home',
  components: {
    ListPedidos,
    SearchBox,
    Menu,
    ModalLoading: () => import('@/components/shared/ModalLoading')
  },
  data: () => ({
    searchBox: false,
    filterDrawer: false,
    item: 1,
    loading: false,
    modalLoading: false,
    orderItems: ['id_saida', 'cliente', 'data_emissao'],
    orderSelected: 'id_saida',
    statusSelected: ['A'],
    filters: {
      search: '',
      order: 'id_saida',
      status: ['P']
    },
    menuItems: [
      { title: 'Gerar Pedido', value: 'gerarPedido' },
      { title: 'Enviar Pedido', value: 'enviarPedido' },
      { title: 'Excluir', value: 'deletePedido', color: 'red--text' },
    ],
    error: ''
  }),
  watch: {
    searchBox(value) {
      if (value) this.$nextTick(() => document.getElementById('searchBox').focus());
      else this.filters.search = '';
    }
  },
  computed: {
    ...mapGetters([
      'pedidos',
      'pedidosSelected',
      'idColaborador',
      'usuario_licenca'
    ]),
    iconSearch() {
      return this.searchBox ? 'mdi-close' : 'mdi-magnify';
    },
    computedTitle() {
      return this.pedidosSelected.length ? `Selecionados (${this.pedidosSelected.length})` : `Pedidos (${this.pedidos.length})`;
    }
  },
  methods: {
    ...mapActions([
      'fetchPedidos', 
      'fetchPedidosAPI', 
      'createPedido', 
      'gerarPedidos',
      'sendPedidosAPI', 
      'deletePedidos',
      'fetchCondicoesPagamentoAPI', 
      'fetchTabelasPrecoAPI',
      'selectAllPedidos',
      'clearPedidosSelected'
    ]),
    ...mapMutations(['SHOW_SNACKBAR']),
    // loadLocalConfig() {
    //   const configPedidos = localStorage.getItem('configPedidos');
    //   if (configPedidos) {
    //     const { order } = JSON.parse(configPedidos);
    //     this.orderSelected = order;
    //     // this.statusSelected = status;
    //     this.filters.order = order;
    //     // this.filters.status = status;
    //   }
    // },
    // saveLocalConfig() {
    //   localStorage.setItem('configPedidos', JSON.stringify({
    //     order: this.orderSelected,
    //     // status: this.statusSelected
    //   }));
    // },
    // TODO: Refatorar quando for liberado na API Syclus
    async insertPedidosAPI() {
      this.loading = true;
      try {
        await this.sendPedidosAPI(this.pedidos);
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async sendPedidosFinalizados() {
      const pedidosFinalizados = this.pedidos.filter(pedido => pedido.qtde_prevista === pedido.qtde_realizada);
      await pedidoService.sendPedidos(pedidosFinalizados);
    },
    async sendPedidos() {
      const pedidos = this.pedidos.filter(pedido => pedido.qtde_realizada > 0);
      await pedidoService.sendPedidos(pedidos);
    },
    async getPedidosAPI() {
      this.loading = true;
      try {
        await this.fetchPedidosAPI();
        await this.fetchCondicoesPagamentoAPI();
        await this.fetchTabelasPrecoAPI();
        this.error = '';
        this.loading = false;
        // this.SHOW_SNACKBAR({ text: 'Lista atualizada com sucesso', status: 'success' });
      } catch (error) {
        this.error = error;
        this.loading = false;
        this.SHOW_SNACKBAR({ text: 'Ocorreu um erro ao atualizar a lista!', status: 'error' });
      }
    },
    async getPedidos() {
      if (!this.pedidos.length) {
        this.loading = true;
        try {
          await this.fetchPedidos();
          this.error = '';
          this.loading = false;
        } catch (error) {
          this.error = error;
          this.loading = false;
          this.SHOW_SNACKBAR({ text: 'Ocorreu um erro ao atualizar a lista!', status: 'error' });
        }
      }
    },
    applyFilters() {
      this.filters.order = this.orderSelected;
      // this.filters.status = this.statusSelected;
      this.filterDrawer = false;
      // this.saveLocalConfig();
    },
    async geraPedido() {
      if (confirm(`Deseja gerar pedido de ${this.pedidosSelected.length} registros?`)) {
        this.modalLoading = true;
        this.loading = true;
        await this.gerarPedidos(this.pedidosSelected);
        this.modalLoading = false;
        this.loading = false;
      }
    },
    async enviaPedido() {
      if (confirm(`Deseja enviar ${this.pedidosSelected.length} registros?`)) {
        this.modalLoading = true;
        this.loading = true;
        await this.sendPedidosAPI(this.pedidosSelected);
        this.clearPedidosSelected();
        this.modalLoading = false;
        this.loading = false;
      }
    },
  },
  created() {
    // this.loadLocalConfig();
    this.getPedidos();
  },
  destroyed() {
    this.clearPedidosSelected();
  }
}
</script>
